
export const Metrics = Object.freeze({
    LIVE_VISIT: 'LIVE_VISIT',
    LIVE_NEW_USER: 'LIVE_NEW_USER',
    LIVE_DUMMY_PROXIMITY: 'LIVE_DUMMY_PROXIMITY',
    LIVE_DUMMY_VIEW: 'LIVE_DUMMY_VIEW',
    WEB_VISIT: 'WEB_VISIT',
    WEB_MAP_VIEW: 'WEB_MAP_VIEW',
    WEB_MAP_ITEM_CLICK: 'WEB_MAP_ITEM_CLICK',
    WEB_MAP_ITEM_LINK_CLICK: 'WEB_MAP_ITEM_LINK_CLICK',
    WEB_MAP_ITEM_AUDIO_PLAY: 'WEB_MAP_ITEM_AUDIO_PLAY'
})

export const DateGroup = Object.freeze({
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
})

export const EnvList = Object.freeze({
    dev: 'dev',
    prod: 'prod'
})